class MarketSiteForm {
    constructor() {
        if (MarketSiteForm.instance) {
            return MarketSiteForm.instance
        }

        MarketSiteForm.instance = this

        this.bindEvents()
    }

    get continentSelect() {
        return document.querySelector('[data-market-site-switch-continent-select] select')
    }

    get countrySelects() {
        return document.querySelectorAll('[data-market-site-switch-country-select]')
    }

    get submitButton() {
        return document.querySelector('[data-market-site-switch-apply]')
    }

    bindEvents() {
        this.continentSelect?.addEventListener('change', this.handleContinentChange.bind(this))
        this.submitButton?.addEventListener('click', this.handleSubmit.bind(this))
    }

    handleContinentChange(event) {
        const selectedContinent = event.target.value

        this.countrySelects.forEach((select) => {
            const continent = select.dataset.marketSiteSwitchCountrySelect

            if (continent === selectedContinent) {
                select.classList.remove('hidden')
            } else {
                select.classList.add('hidden')
            }
        })
    }

    handleSubmit() {
        this.countrySelects.forEach((select) => {
            if (!select.classList.contains('hidden')) {
                const selectedOption = select.querySelector('select').querySelector('option:checked')
                window.location.href = selectedOption.value
            }
        })
    }

    static create() {
        return new MarketSiteForm()
    }
}

export default MarketSiteForm
